<template>
  <el-dialog
    :visible="visible"
    title="ВЫБОР ЗАКАЗЧИКА"
    width="50%"
    class="choosing-client-modal"
    append-to-body
    @close="onClose"
  >
    <el-table v-loading="loading" :data="list" style="width: 100%">
      <el-table-column label="Название" prop="short_name" />
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Поиск по ИНН и названию"
            :disabled="loading"
            @blur="fetchList"
            @keyup.enter.native="fetchList"
          />
        </template>
        <template slot-scope="scope">
          <b v-if="client && scope.row.id === client.id" class="chosen">
            Выбрано
          </b>
          <el-button v-else size="mini" @click="onSet(scope.row)">
            Выбрать
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <section class="bottom-section">
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
    </section>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PaginationCustom from '@/components/Tables/PaginationCustom'

export default {
  name: 'ClientFieldModal',
  components: { PaginationCustom },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: '',
      page: 1,
    }
  },
  created() {
    this.fetchList()
  },
  computed: {
    ...mapGetters({
      getClients: 'clients/getList',
      pagination: 'clients/getPagination',
      loading: 'clients/getLoading',
    }),
    list() {
      return this.getClients()
    },
  },
  methods: {
    ...mapActions({ fetchClients: 'clients/fetchClients' }),
    fetchList() {
      const { search, page } = this

      this.fetchClients({ search, page })
    },
    changePage(page = 1) {
      this.page = page
      this.fetchList()
    },
    onSet(val) {
      this.$emit('set', val)
      this.onClose()
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.choosing-client-modal
  .el-dialog__body
    padding: 0 50px 50px
    .chosen
      color: #67c23a
</style>
